module.exports = __webpack_public_path__ + "static/media/5_product-desc.a332748e.svg";